import type { CSSProperties } from 'react';

type ApprovalAccountSummaryProps = {
  name?: string;
  email?: string;
};

export function ApprovalAccountSummary({ name, email }: ApprovalAccountSummaryProps) {
  const displayName = name?.trim();
  const displayEmail = email?.trim();
  if (!displayName && !displayEmail) return null;

  const primary = displayName || displayEmail || 'Conta';

  return (
    <div style={accountSummaryStyle}>
      <div style={accountAvatarStyle}>{primary.slice(0, 1).toUpperCase()}</div>
      <div style={{ minWidth: 0, textAlign: 'left' }}>
        {displayName && (
          <div style={accountNameStyle} title={displayName}>{displayName}</div>
        )}
        {displayEmail && (
          <div style={accountEmailStyle} title={displayEmail}>{displayEmail}</div>
        )}
      </div>
    </div>
  );
}

const accountSummaryStyle: CSSProperties = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '10px 0 12px',
  marginTop: 10,
  borderTop: '1px solid #eef2f7',
  borderBottom: '1px solid #eef2f7',
};

const accountAvatarStyle: CSSProperties = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  background: '#dbeafe',
  color: '#1d4ed8',
  fontSize: '0.9rem',
  fontWeight: 800,
};

const accountNameStyle: CSSProperties = {
  color: '#1e293b',
  fontSize: '0.82rem',
  fontWeight: 800,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const accountEmailStyle: CSSProperties = {
  color: '#64748b',
  fontSize: '0.74rem',
  fontWeight: 600,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
